var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroupPaymentWhite(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3608_5805",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3608_5805)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.6702 9.81799C18.568 9.79859 20.9807 12.1595 21.0065 15.0508C21.0324 18.0068 18.6456 20.426 15.7025 20.4389C12.8112 20.4518 10.4115 18.0715 10.3986 15.1737C10.3792 12.2177 12.7207 9.8374 15.6702 9.81152V9.81799Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.62488 9.00275C6.98841 8.92513 5.41015 8.6858 3.94185 7.94195C3.54082 7.73497 3.15272 7.4633 2.83578 7.13989C2.24717 6.54481 2.27951 5.96266 2.86812 5.36111C3.41145 4.79837 4.09709 4.46202 4.82154 4.22916C7.52527 3.35595 10.2161 3.36888 12.8681 4.41674C13.3726 4.61726 13.8577 4.93421 14.2717 5.28349C14.9897 5.89151 14.9767 6.59655 14.2911 7.24338C13.4955 8.00017 12.4929 8.37533 11.445 8.58878C10.5136 8.78283 9.56278 8.86045 8.61841 8.99628L8.62488 9.00275Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1413 10.632C9.81146 11.2141 9.51392 11.7639 9.19697 12.3008C9.1517 12.372 9.04174 12.4496 8.95765 12.456C7.19828 12.4949 5.49066 12.2685 3.89946 11.4599C3.60192 11.3047 3.31732 11.1171 3.05859 10.9037C2.45704 10.3927 2.33414 9.99163 2.45704 9.15723C4.84383 10.5738 7.44407 10.839 10.1349 10.6385L10.1413 10.632Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0495 19.4749C9.6032 19.5007 9.18923 19.546 8.76879 19.546C7.23581 19.546 5.72871 19.3584 4.31216 18.7375C3.94993 18.5758 3.60711 18.3688 3.27076 18.1553C2.5916 17.709 2.27465 17.0881 2.44283 16.2666C2.93441 16.4995 3.41953 16.7647 3.93053 16.9652C5.48291 17.5732 7.09998 17.806 8.75586 17.7672C9.02106 17.7672 9.15042 17.8384 9.27332 18.0907C9.49324 18.5564 9.76491 18.9897 10.043 19.4813L10.0495 19.4749Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.45603 12.6832C4.36417 13.8475 6.45342 14.2097 8.63323 14.2356V16.0079C7.67592 16.0079 6.73803 15.9109 5.80659 15.6845C4.89457 15.4711 4.02782 15.1541 3.2581 14.6043C2.59833 14.1386 2.27492 13.5306 2.45603 12.6768V12.6832Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupPaymentWhite);
export default __webpack_public_path__ + "static/media/group_payment_white.0e458a4e4e911ed4387fcacdb5d8888a.svg";
export { ForwardRef as ReactComponent };